import { render, staticRenderFns } from "./ShowPdf.vue?vue&type=template&id=636aa9db&scoped=true&"
import script from "./ShowPdf.vue?vue&type=script&lang=js&"
export * from "./ShowPdf.vue?vue&type=script&lang=js&"
import style0 from "./ShowPdf.vue?vue&type=style&index=0&id=636aa9db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636aa9db",
  null
  
)

export default component.exports